import React from "react";
import moment from "moment";
import _ from "lodash";

import InputSelectField from "./InputSelectField";
import InputDateField from "./InputDateField";
import InputTextField from "./InputTextField";

import {
  convertUnixMsToDateInTimezone,
  formatDateForDisplay,
} from '../../Utils/date';

import "./ParkerStatus.scss";

class ParkerStatusTableDataRow extends React.Component {
  state = {
    editMode: false,
  };

  componentDidUpdate(prevProps) {
    if (this.props.editMode !== prevProps.editMode && !this.props.editMode) {
      this.setState({ editMode: this.props.editMode });
    }
  }

  _onInputChange(inputId) {
    return (value) => {
      const { onChange } = this.props;

      const entry = _.cloneDeep(this.props.historyItem);
      entry[inputId] = value;

      onChange(entry);
    };
  }

  getDate = (value, key) => {
    let date = value
      ? key
        ? moment(value).add(1, "day").format("YYYY-MM-DD")
        : moment(value).format("YYYY-MM-DD")
      : null;
    return date;
  };

  getAction = (action) => {
    switch (action) {
      case "PARKER_START_DATE":
        return "Start Date";
      case "ACCESS_SYSTEM_START_DATE":
        return "Access System Start Date";
      case "SUSPEND":
        return "Suspend";
      case "TERMINATE":
        return "Terminate";
      default:
    }
  };

  onEditButtonClick = () => {
    const { handleEdit, historyItem, handleChange } = this.props;
    handleEdit();
    handleChange("Inputs")(historyItem);
    this.setState({ editMode: true });
  };

  render() {
    const { editMode } = this.state;
    const {
      parker,
      historyItem,
      handleDelete,
      showAccessStatus,
      isAddMode,
      showErrors,
      handleChange,
      reqError,
      fieldConfiguration,
    } = this.props;

    const { facilityTimezone } = fieldConfiguration;

    const startDate = historyItem.start_date ? formatDateForDisplay(historyItem.start_date) : '';
    const endDate = historyItem.end_date ? formatDateForDisplay(historyItem.end_date) : '';

    const action = this.getAction(historyItem.action);
    const accessStatus = parker.access_system_status.value || "OFF";
    const suspensionStartDate = action === "Suspend" ? startDate : "";
    const suspensionEndDate = action === "Suspend" ? endDate : "";
    const noEndDate = action === "Suspend" && historyItem.noEndDate;
    const terminationDate = action === "Terminate" ? startDate : null;
    const dateRecorded = convertUnixMsToDateInTimezone(historyItem.created_at, facilityTimezone);
    const parkerStartDate = (action === "Start Date" || action === "Access System Start Date") ? startDate : "";
    const notes = historyItem.notes;
    const checkDates =
      showErrors &&
      !noEndDate &&
      suspensionEndDate !== "" && suspensionStartDate !== "" &&
      !moment(suspensionStartDate).isBefore(suspensionEndDate);

    return (
      <div className="parkerstatus-line-item-entry-table-row">
        <div className="parkerstatus-line-item-entry-table--date-recorded-column parkerstatus-line-item-entry-table--cell">
          {dateRecorded}
        </div>
        <div className="parkerstatus-line-item-entry-table--action-column parkerstatus-line-item-entry-table--cell">
          {action}
        </div>
        <div className="parkerstatus-line-item-entry-table--parker-start-date-column parkerstatus-line-item-entry-table--cell">
          {parkerStartDate}
        </div>
        {showAccessStatus && (
          <div className="parkerstatus-line-item-entry-table--access-status-column parkerstatus-line-item-entry-table--cell">
            {accessStatus}
          </div>
        )}
        <div
          className={`parkerstatus-line-item-entry-table--sus-start-date-column parkerstatus-line-item-entry-table--cell ${
            showErrors && !suspensionStartDate && "show-error"
          }`}
        >
          {action === "Suspend" &&
          editMode &&
          (moment().isBefore(suspensionStartDate) || !suspensionStartDate) ? (
            <>
              <InputSelectField
                id="parkerstatus-line-item-entry-table--start-date-input"
                options={this.props.getDates("startDate")}
                value={
                  editMode
                    ? moment(suspensionStartDate).format("YYYY-MM-DD")
                    : suspensionStartDate
                }
                editMode={true}
                onChange={(value) => {
                  this._onInputChange("start_date")(this.getDate(value));
                  handleChange("selectedSuspensionStartDate")(value);
                }}
              />
              <span className="error">
                {showErrors &&
                  !suspensionStartDate &&
                  "Please provide a Suspension Start Date"}
              </span>
            </>
          ) : (
            suspensionStartDate
          )}
        </div>
        <div
          className={`parkerstatus-line-item-entry-table--sus-end-date-column parkerstatus-line-item-entry-table--cell ${
            ((showErrors && !suspensionEndDate) || checkDates || reqError) &&
            "show-error"
          }`}
        >
          {action === "Suspend" &&
          editMode &&
          (moment().isBefore(suspensionEndDate) || !suspensionEndDate) ? (
            <>
              <InputSelectField
                id="parkerstatus-line-item-entry-table--start-date-input"
                options={this.props.getDates("endDate")}
                value={
                  editMode
                    ? moment(suspensionEndDate).format("YYYY-MM-DD")
                    : suspensionEndDate
                }
                editMode={
                  moment().isBefore(suspensionEndDate) || !suspensionEndDate
                }
                disabledMode={noEndDate}
                onChange={(value) => {
                  this._onInputChange("end_date")(this.getDate(value));
                  handleChange("selectedSuspensionEndDate")(value);
                }}
              />
              <span className="error">
                {showErrors &&
                  !suspensionEndDate &&
                  !noEndDate &&
                  "Please provide a Suspension End Date"}
              </span>
              <span className="error">
                {checkDates && "Please review suspension dates selected"}
              </span>
              <span className="error">{!showErrors && reqError}</span>
            </>
          ) : (
            suspensionEndDate
          )}
        </div>
        <div className="parkerstatus-line-item-entry-table--no-end-date-column parkerstatus-line-item-entry-table--cell">
          {action === "Suspend" && (
            <input
              type="checkbox"
              checked={noEndDate}
              onChange={(e) => {
                this._onInputChange("noEndDate")(e.target.checked);
                handleChange("isNoEndDate")(e.target.checked);
                setTimeout(() => {
                  this._onInputChange("end_date")(null);
                  handleChange("selectedSuspensionEndDate")(null);
                }, 100);
              }}
              disabled={!editMode}
            />
          )}
        </div>
        <div className={`parkerstatus-line-item-entry-table--termination-date-column parkerstatus-line-item-entry-table--cell ${reqError && "show-error"}`}>
          {action === "Terminate" &&
          editMode ? (
            <>
              <InputDateField
                id="parkerstatus-line-item-entry-table--suspension-end-date-input"
                value={editMode ? new Date(terminationDate) : terminationDate}
                editMode={true}
                showError={terminationDate === null}
                errorMessage="Please provide a Termination Date"
                onChange={(value) => {
                  this._onInputChange("start_date")(
                    this.getDate(value, "terminate")
                  );
                  handleChange("terminationDate")(
                    this.getDate(value, "terminate")
                  );
                }}
              />
              <span className="error">{reqError}</span>
            </>
          ) : (
            terminationDate
          )}
        </div>
        <div className="parkerstatus-line-item-entry-table--notes-column parkerstatus-line-item-entry-table--cell">
          <InputTextField
            inputId="parkchirp--transaction-table--notes"
            value={notes}
            multiLine={true}
            editMode={editMode}
            onChange={this._onInputChange("notes")}
            maxlength="255"
          />
        </div>
        <div className="parkerstatus-line-item-entry-table--action-column parkerstatus-line-item-entry-table--cell">
          { (moment().isBefore(suspensionEndDate) ||
            moment().isBefore(terminationDate) || 
            noEndDate) && (
            <>
              <button
                className={`parkchirp--button-as-link ${
                  !historyItem.isEditable ? "disabled--button" : ""
                }`}
                onClick={this.onEditButtonClick}
                disabled={!historyItem.isEditable || isAddMode}
              >
                <span>Edit</span>
              </button>
              {(moment().isBefore(suspensionStartDate) || moment().isBefore(terminationDate)) && 
              <button
                className="parkchirp--button-as-link parkchirp-button-delete"
                onClick={() => {
                  handleDelete(historyItem.id);
                }}
              >
                <span>Delete</span>
              </button>}
            </>
          )}
        </div>
      </div>
    );
  }
}

export default ParkerStatusTableDataRow;
